import './styles/HouseholdIcon.scss';
import React from 'react';
import FA from "../../utils/FA";
import {faHouse} from "@fortawesome/pro-solid-svg-icons/faHouse";

export default () => {
  return (
    <div className="sp-household">
      <div className="fa-layers fa-fw sp-household-icon">
        <FA icon={faHouse} className='fa-3x'/>
      </div>
    </div>
  );
};
